export default __webpack_public_path__ + "static/media/misc-bathtubA-768w.0a434cc6.png";